// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".per-page-selector[data-v-4063d014]{width:90px}[dir] .icon-activity[data-v-4063d014]{cursor:pointer}[dir=ltr] .icon-activity[data-v-4063d014]{margin-left:.5rem}[dir=rtl] .icon-activity[data-v-4063d014]{margin-right:.5rem}.icon-activity[data-v-4063d014]:hover{color:var(--white)!important}[dir] .icon-activity[data-v-4063d014]:hover{background-color:var(--primary)!important}", ""]);
// Exports
module.exports = exports;
